import React from "react";
import _ from "lodash";
import ColorCollectionItem from "./ColorCollectionItem";

const ColorCollectionGrid = ({
  colors,
  availableColors=undefined,
  selected=null,
  onColorClick = () => {},
  containerStyle={},
  intensityGroups=undefined,
  intensityGroupsBgColor=undefined,
  intensityGroupsExtraCls=undefined,
}) => {

  const cellCls = "w-20";
  return (
    <div className="flex flex-row gap-5 items-center" style={containerStyle}>
      {(intensityGroups ?? [[""]]).map((labels, idx) => (
        <div key={`ig-${idx}`} className="flex flex-col gap-1">
          {labels.map((t) => {
            const groupColors = colors.filter((c) => !!t ? c.intensity === t : true);
            if (groupColors.length === 0)
              return null;
            const rows = _.groupBy(groupColors, (c) => c.grid_position_row);
            const maxCol = groupColors.reduce((prev, curr) => Math.max(prev, curr.grid_position_col), -1);
            return (
              <div key={t} className={`flex flex-row gap-2 ${intensityGroupsExtraCls?.[t] ?? ""}`}>
                {!!t && (
                  <div
                    className={`w-6 flex flew-row items-center border-r border-black sticky left-0 z-30 ${intensityGroupsBgColor}`}
                    style={{left: "-1px"}}
                  >
                    <div
                      className="whitespace-nowrap text-xs select-none px-2 sticky top-0 bottom-0 pointer-events-none"
                      style={{transform: "rotate(-90deg)", aspectRatio: "1"}}
                    >
                      {_.capitalize(t)} Tones
                    </div>
                  </div>
                )}
                <div className="flex flex-col gap-1">
                  {Object.entries(rows).map(([r, items]) => (
                    <div key={r} className="w-full flex gap-0.5">
                      {
                        [...Array(maxCol + 1).keys()].map((col, idx) => {
                          const target = items.find((i) => i.grid_position_col === col);
                          return target ? (
                            <ColorCollectionItem
                              key={idx}
                              onClick={onColorClick}
                              className={cellCls}
                              isUnfocused={!!selected && selected !== target.code && colors.some((c) => c.code === selected)}
                              isDisabled={!!availableColors && !availableColors.some((c) => c === target.code)}
                              {...{...target}}
                            />
                          ) : (
                            <div key={idx} className={cellCls} />
                          );
                        })
                      }
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default ColorCollectionGrid;